/* ===========================================================
   CALMA ANIMALS — zamiana na zestaw
   - snippets/calma-zestaw-swap.liquid: pary GEL+SPRAY kupione osobno → zestaw,
   - sections/calma-cart.liquid (data-kind="upgrade"): sam GEL/SPRAY → zestaw z dopłatą.
   Przycisk niesie gotowe `updates` dla /cart/update.js.
   - Strona /cart (#calma-cart) jest renderowana serwerowo → przeładowanie.
   - Szuflada (Horizon) → zdarzenie 'cart:update' z nowym HTML sekcji,
     tak jak robi to component-cart-items.js (morph szuflady, licznik, pasek dostawy).
   =========================================================== */
(function () {
  'use strict';

  if (window.__calmaZestawSwap) return;
  window.__calmaZestawSwap = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionIds() {
    var ids = [];
    var els = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < els.length; i++) {
      var id = els[i].getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function fail(btn, label) {
    btn.disabled = false;
    btn.textContent = label;
    var box = btn.closest('[data-calma-swap-box]');
    var err = box && box.querySelector('[data-calma-swap-err]');
    if (err) err.hidden = false;
  }

  // Wspólna ścieżka dla przycisku i automatu: cart/update.js + odświeżenie szuflady albo strony /cart.
  function runSwap(updates, opts) {
    var body = { updates: updates };
    if (opts.attributes) body.attributes = opts.attributes;
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }

    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (cart) {
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('calma_zestaw_swap', {
              kind: opts.kind,
              saving: opts.saving || 0,
              total_price: cart.total_price,
            });
          }
        } catch (e) {}

        if (document.getElementById('calma-cart')) {
          window.location.reload();
          return;
        }

        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: cart,
          sourceId: 'calma-zestaw-swap',
          data: {
            source: 'calma-zestaw-swap',
            itemCount: cart.item_count,
            sections: cart.sections || {},
          },
        };
        document.dispatchEvent(ev);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-calma-swap]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var updates;
    try {
      updates = JSON.parse(btn.getAttribute('data-calma-swap'));
    } catch (e) {
      return;
    }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Zamieniam…';

    runSwap(updates, {
      kind: btn.getAttribute('data-kind') || 'swap',
      saving: parseInt(btn.getAttribute('data-saving'), 10) || 0,
    }).catch(function (err) {
      console.error('calma-zestaw-swap', err);
      fail(btn, label);
    });
  });

  /* Od 31.10: para GEL + SPRAY tej samej pojemności sama przechodzi na SKU zestawu.
     Znacznik [data-calma-autoswap] renderuje snippets/calma-zestaw-swap.liquid (szuflada i /cart).
     Jedna próba na dany układ koszyka (sessionStorage), żeby błąd nie zapętlił zapytań. */
  var autoBusy = false;

  function tryAuto() {
    if (autoBusy) return;
    var el = document.querySelector('[data-calma-autoswap]');
    if (!el) return;
    var raw = el.getAttribute('data-calma-autoswap');
    var key = 'calmaAutoSwap:' + raw;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}

    var updates;
    try {
      updates = JSON.parse(raw);
    } catch (e) {
      return;
    }

    autoBusy = true;
    runSwap(updates, { kind: 'auto', attributes: { _calma_zestaw_auto: '1' } })
      .catch(function (err) {
        console.error('calma-zestaw-swap auto', err);
      })
      .then(function () {
        autoBusy = false;
      });
  }

  var autoTimer = null;
  function scheduleAuto() {
    clearTimeout(autoTimer);
    autoTimer = setTimeout(tryAuto, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAuto);
  } else {
    scheduleAuto();
  }
  // Szuflada Horizon podmienia treść morphem po każdej zmianie koszyka — łapiemy nowy znacznik.
  new MutationObserver(function () {
    if (document.querySelector('[data-calma-autoswap]')) scheduleAuto();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
